import classNames from 'classnames'
import React from 'react'

export interface ContentTextProps {
    title?: React.ReactNode
    subtitle?: React.ReactNode
    list?: {
        icon?: React.ReactNode
        text: React.ReactNode
        textClassName?: string
    }[]
    footer?: React.ReactNode
    className?: string
    titleClassName?: string
}

export const ContentText: React.FC<ContentTextProps> = ({
    title,
    subtitle,
    list,
    footer,
    className = '',
    titleClassName = 'text-heading-3',
}) => {
    // If no content is provided, return null to avoid rendering empty elements
    if (!title && !subtitle && (!list || list.length === 0) && !footer) {
        return null
    }

    const containerClassName = classNames(
        'ml-0 flex w-full lg:max-w-[488px] flex-col items-start justify-center text-left',
        className
    )

    return (
        <div className={containerClassName} data-testid="content-text">
            {title && (
                <div
                    className={`${titleClassName} mb-4 font-bold capitalize leading-tight`}
                    data-testid="content-text-title"
                >
                    {title}
                </div>
            )}
            {subtitle && (
                <div
                    className="text-body-medium text-gray-700 mb-4"
                    data-testid="content-text-subtitle"
                >
                    {subtitle}
                </div>
            )}
            {list && list.length > 0 && (
                <ul
                    className="mb-4 flex flex-col gap-4"
                    data-testid="content-text-list"
                >
                    {list.map((item, idx) => (
                        <li
                            key={idx}
                            className="text-body-medium flex items-start gap-2"
                            data-testid={`content-text-list-item-${String(idx)}`}
                        >
                            {item.icon && (
                                <span className="h-5 w-5 flex-shrink-0 text-blue-600">
                                    {item.icon}
                                </span>
                            )}
                            <span className={item.textClassName}>
                                {item.text}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
            {footer && (
                <div
                    className="text-body-medium mb-4"
                    data-testid="content-text-footer"
                >
                    {footer}
                </div>
            )}
        </div>
    )
}
